import type { LovDrDTO } from '@/features/api/extranet/dto/Demande/DR'
import type { DemandeStore } from '@/features/interface/demande/shared'
import { buildDemandeActions } from '@/features/interface/demande/shared'
import { type InjectionKey } from 'vue'

type DemandeCXPIActions = ReturnType<typeof useDRActions>
export const DR_ACTIONS: InjectionKey<DemandeCXPIActions> = Symbol('cxpi-actions')

export function useDRActions(store: DemandeStore<'MODEL_DR', LovDrDTO>) {
  // const { model, readonly } = storeToRefs(store)
  // const eventBus = useEventBus()

  // typeDocumentTemplate: computed(() => null),
  const actionsDemande = buildDemandeActions(store)

  return {
    ...actionsDemande,
  }
}
